/** Static “Why Choose Career Grad” cards — matches `/home1` source of truth. */
export type MarketingWhyChooseIcon =
  | 'brain-cog'
  | 'shield-check'
  | 'landmark'
  | 'plane-takeoff'
  | 'globe';

export type MarketingWhyChooseFeature = {
  icon: MarketingWhyChooseIcon;
  title: string;
  description: string;
  tone: 'featured' | 'accent' | 'plain';
  link?: { label: string; href: string };
};

export const MARKETING_WHY_CHOOSE_HEADING = {
  title: 'Why Choose Career Grad',
  subtitle:
    'Premium counseling, real outcomes, no upsells. Built on a decade of helping students land at their dream campus.',
} as const;

export const MARKETING_WHY_CHOOSE_FEATURES: MarketingWhyChooseFeature[] = [
  {
    icon: 'brain-cog',
    title: 'Personalized Profile Analysis',
    description:
      'Our experts dive deep into your academic background, career goals, and financial constraints to curate a list of universities that guarantee the best ROI.',
    tone: 'featured',
    link: { label: 'Learn more about our method', href: '#cta' },
  },
  {
    icon: 'shield-check',
    title: '99% Visa Success',
    description: 'Meticulous documentation and mock interview sessions that ensure you never face a rejection.',
    tone: 'accent',
  },
  {
    icon: 'landmark',
    title: 'Loan Assistance',
    description: 'Hassle-free education loans from top banks with quick processing times.',
    tone: 'plain',
  },
  {
    icon: 'plane-takeoff',
    title: 'Post-Landing Support',
    description: "We don't stop at the airport. We help with accommodation and local guidance.",
    tone: 'plain',
  },
  {
    icon: 'globe',
    title: 'Global Network',
    description: 'Connect with our alumni network in over 15 countries for real-world advice.',
    tone: 'plain',
  },
];
